import React, { Component } from 'react'

class PanelHeader extends Component {
    render() {
        const { children, cssClass, noDivider } = this.props
        return (
            <div className={`panelHeader ${cssClass || ''}`}>
                {children}
                {!noDivider && <hr />}
            </div> 
        )
    }
}

export default PanelHeader
